<template>
  <div>
    <div class="bg-charcoal-100 dark:bg-dark-950">
      <div class="max-w-wrapper-3xs mx-auto font-medium leading-snug p-6 text-center">
        <template v-if="isWaiting">
          <ImageEmoji name="Crossed+Fingers" class="size-12 mx-auto" />

          <p class="font-bold text-2xl mt-2">
            {{ $t('components.Event.confirmation.waiting.title') }}
          </p>

          <p class="mt-2">
            {{ $t('components.Event.confirmation.waiting.content') }}
          </p>
        </template>
        <template v-else-if="event.isAttended(currentUser?._id)">
          <ImageEmoji name="Grinning+Face" class="size-12 mx-auto" />

          <p class="font-bold text-2xl mt-2">
            {{ $t('components.Event.confirmation.attended.title') }}
          </p>

          <p class="mt-2">
            {{ $t('components.Event.confirmation.attended.content') }}
          </p>
        </template>
        <template v-else>
          <ImageEmoji name="Grinning+Face" class="size-12 mx-auto" />

          <p class="font-bold text-2xl mt-2">
            {{ $t('components.Event.confirmation.attending.title') }}
          </p>

          <p class="mt-2">
            {{ $t('components.Event.confirmation.attending.content') }}
          </p>

          <EventCalendarButton
            :event="event"
            :button="{
              color: 'white',
              size: 'sm'
            }"
            type="button"
            class="mt-3 max-w-60 mx-auto"
          />
        </template>
      </div>

      <div class="bg-white border-t border-charcoal-200 dark:bg-dark-800 dark:border-dark-600 flex items-center space-x-2 p-2.5">
        <template v-if="isWaiting">
          <ButtonBase is-full color="white" @click="() => emit('reset')">
            {{ $t('actions.understood') }}
          </ButtonBase>
        </template>
        <template v-else-if="event.isAttended(currentUser?._id)">
          <ButtonBase is-full color="builders" :to="{ name: 'app-hangout-organize' }">
            {{ $t('components.Event.actions.organize') }}
          </ButtonBase>
        </template>
        <template v-else>
          <ButtonBase color="royal" class="shrink-0" style-type="round" :to="{ name: 'app-conversation-id', params: { id: event.conversations[0] }}" v-if="event.conversations[0]">
            <IconBase name="cute/message-fill" />
          </ButtonBase>

          <ButtonBase is-full color="builders" :to="{ name: 'app-feed-post', query: { postCreateEvent: event._id, postCreateText } }">
            {{ $t('components.Event.actions.share') }}
          </ButtonBase>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'
import WindowStore from '@/store/window'
import { Event } from '@/classes'
import ButtonBase from '@/components/Button/ButtonBase.vue'
import ImageEmoji from '@/components/Image/ImageEmoji.vue'

const props = defineProps<{
  event: Event
}>()

const { event } = toRefs(props)

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'reset'): void
  (e: 'previous'): void
}>()

const windowStore = WindowStore()
const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const isWaiting = computed(() => event.value?.isWaiting(currentUser.value?._id))

const postCreateText = useNuxtApp().$i18n.t(`components.Event.share.predefined.${randomBetween(0, 10)}`)

onMounted(() => {
  if (isWaiting.value) return

  const emoji = [ '🌈', '❤️', '☀️', '✨', '🎉' ][ randomBetween(0, 4) ] as string

  // windowStore.addConfetti({
  //   confettiNumber: 30,
  //   emojiSize: 60,
  //   emojis: [ emoji ]
  // })
})

</script>